(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('AnagraficaProtocolloDetailController', AnagraficaProtocolloDetailController);

    AnagraficaProtocolloDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function AnagraficaProtocolloDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.anagraficaProtocollo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:anagraficaProtocolloUpdate', function (event, result) {
            vm.anagraficaProtocollo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
